import { Table, TableContainer } from '@material-ui/core';
import { User } from '@nemuru-eng/js-api-client';

import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { UserTableBody } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/UserTableBody';
import { useUserTable } from '@/components/shared/components/UserList/hooks/useUserTable';
import { UserListTableProps } from '@/components/shared/components/UserList/types/TableProps';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';

interface UserTableProps extends UserListTableProps {
  users: User[];
  editModeAllowed: boolean;
  userId?: string;
}

export const UserTable = ({ users, userId, editModeAllowed, tableProps }: UserTableProps) => {
  const tableElementId = 'user-table-container';
  const { classes, stickyCellStyle } = useDefaultTable({
    tableElementId,
  });
  const { columns } = useUserTable({ tableProps });

  return (
    <>
      <TableContainer id={tableElementId}>
        <Table>
          <CustomHeader
            tableProps={{ classes, stickyCellStyle: { ...stickyCellStyle, minWidth: '50px' } }}
            columns={columns}
          />
          <UserTableBody userId={userId} users={users} editModeAllowed={editModeAllowed} tableProps={tableProps} />
        </Table>
      </TableContainer>
    </>
  );
};
